module.exports = __webpack_public_path__ + "img/list_12_tc.2860b0a8.png";